import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ApisService } from '../services/apis.service';
import { SessionGuardService } from '../services/session-guard.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authServ: ApisService,
    private router: Router,
    private session: SessionGuardService
  ) {}

  canActivate(_route: ActivatedRouteSnapshot): any {
    return this.authServ.checkAuth().then(async (user) => {
      //  Un correo sin verificar no pasa (NV-35, NV-51): conserva la sesión de Auth solo para
      //  poder reenviar el correo desde el login.
      if (user && (user as { emailVerified?: boolean }).emailVerified) {
        //  Una cuenta suspendida con la sesión abierta no sigue (NV-31): se cierra y vuelve al
        //  login con el aviso. Si la lectura falla por cuenta deshabilitada, es el mismo camino.
        if (await this.authServ.isAccountSuspended((user as { uid: string }).uid)) {
          await this.session.endSuspendedSession();
          return false;
        }
        return true;
      } else {
        void this.router.navigate(['login']);
      }
    });
  }
}
